import { RouteObject } from "react-router-dom";
import {
  LoginPage,
  MfaVerificationPage,
  RequestPasswordResetPage,
  ResetPasswordPage,
  ResetPasswordSentPage,
  ForcedPasswordResetPage,
  UnauthorizedPage,
} from "../pages/auth";
import HomePage from "../pages/HomePage";
import ProfilePage from "../pages/ProfilePage";
import VerifyEmailPage from "../pages/VerifyEmailPage";
import NotFoundPage from "../pages/NotFoundPage";
import {
  UserListPage,
  CreateUserPage,
  EditUserPage,
  UserDetailsPage,
  BulkImportPage,
} from "../pages/users";
import {
  CashOutListPage,
  CashOutCreatePage,
  CashOutEditPage,
  CashOutDetailPage,
  CashOutReportsPage,
} from "../pages/cashOut";
import { EmailTestingPage } from "../pages/admin";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "../components/Layout/Layout";
// import { UserRoleEnum } from '@shared/schemas'; // Commented out as it's not used

const routes: RouteObject[] = [
  // Protected routes with layout
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "profile",
        element: <ProfilePage />,
      },
      // User management routes - ADMIN only
      {
        path: "users",
        element: (
          <ProtectedRoute requiredRoles={["ADMIN"]}>
            <UserListPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "users/create",
        element: (
          <ProtectedRoute requiredRoles={["ADMIN"]}>
            <CreateUserPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "users/import",
        element: (
          <ProtectedRoute requiredRoles={["ADMIN"]}>
            <BulkImportPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "users/:id",
        element: (
          <ProtectedRoute requiredRoles={["ADMIN"]}>
            <UserDetailsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "users/edit/:id",
        element: (
          <ProtectedRoute requiredRoles={["ADMIN"]}>
            <EditUserPage />
          </ProtectedRoute>
        ),
      },
      // Cash Out routes - All authenticated users
      {
        path: "cash-outs",
        element: (
          <ProtectedRoute
            requiredRoles={["ADMIN", "MANAGER", "SUPERVISOR", "SERVER", "USER"]}
          >
            <CashOutListPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "cash-outs/create",
        element: (
          <ProtectedRoute
            requiredRoles={["ADMIN", "MANAGER", "SUPERVISOR", "SERVER", "USER"]}
          >
            <CashOutCreatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "cash-outs/:id",
        element: (
          <ProtectedRoute
            requiredRoles={["ADMIN", "MANAGER", "SUPERVISOR", "SERVER", "USER"]}
          >
            <CashOutDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "cash-outs/:id/edit",
        element: (
          <ProtectedRoute
            requiredRoles={["ADMIN", "MANAGER", "SUPERVISOR", "SERVER", "USER"]}
          >
            <CashOutEditPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "cash-outs/reports",
        element: (
          <ProtectedRoute requiredRoles={["ADMIN", "MANAGER"]}>
            <CashOutReportsPage />
          </ProtectedRoute>
        ),
      },
      // Admin routes - ADMIN only
      {
        path: "admin/email-testing",
        element: (
          <ProtectedRoute requiredRoles={["ADMIN"]}>
            <EmailTestingPage />
          </ProtectedRoute>
        ),
      },
    ],
  },

  // Auth routes
  {
    path: "/auth/login",
    element: <LoginPage />,
  },
  {
    path: "/auth/mfa",
    element: <MfaVerificationPage />,
  },
  {
    path: "/auth/reset-password-request",
    element: <RequestPasswordResetPage />,
  },
  {
    path: "/auth/reset-password/:token",
    element: <ResetPasswordPage />,
  },
  {
    path: "/auth/reset-password-sent",
    element: <ResetPasswordSentPage />,
  },
  {
    path: "/auth/forced-password-reset",
    element: <ForcedPasswordResetPage />,
  },

  // Email verification route (public)
  {
    path: "/verify-email",
    element: <VerifyEmailPage />,
  },

  // Unauthorized page
  {
    path: "/unauthorized",
    element: <UnauthorizedPage />,
  },

  // Not found - 404 page
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
